import React from "react"

const FootnotesBackLink = (props) => {
    return <a {...props} className="footnote-backref">↩</a>;
}

export default FootnotesBackLink